function Inicio() {
    return (
        <>
        <section class="page-section" id="services">
            <div class="container">
                <div class="text-center">
                    <h2 class="section-heading text-uppercase">¿POR QUÉ KIMCHILINGUA?</h2>
                </div>
                <div class="row text-center">
                    <div class="col-md-4">
                        <span class="fa-stack fa-4x">
                            <i class="fas fa-circle fa-stack-2x text-primary"></i>
                            <i class="fas fa-shopping-cart fa-stack-1x fa-inverse"></i>
                        </span>
                        <h4 class="my-3">Profesora nativa</h4>
                        <p class="text-muted">Es muy difícil corregir un mal hábito lingüístico después de tenerlo. Aprende el coreano más correcto con un hablante nativo desde el principio.</p>
                    </div>
                    <div class="col-md-4">
                        <span class="fa-stack fa-4x">
                            <i class="fas fa-circle fa-stack-2x text-primary"></i>
                            <i class="fas fa-laptop fa-stack-1x fa-inverse"></i>
                        </span>
                        <h4 class="my-3">Profesora certificada</h4>
                        <p class="text-muted">Saber usar bien el idioma y enseñarlo bien son dos cosas diferentes. Estudiar coreano con una profesora con el certificado de enseñanza  de coreano para extranjeros es el atajo para conquistar el idioma.</p>
                    </div>
                    <div class="col-md-4">
                        <span class="fa-stack fa-4x">
                            <i class="fas fa-circle fa-stack-2x text-primary"></i>
                            <i class="fas fa-lock fa-stack-1x fa-inverse"></i>
                        </span>
                        <h4 class="my-3">Profesora políglota</h4>
                        <p class="text-muted">Yo tengo dominio de coreano(nativo), español(superior), inglés(superior) y portugués(intermedio).  No intentes memorizar el idioma sin entender. Solucionaré todas tus dudas.</p>
                    </div>
                </div>
                <div class="row text-center">
                    <div class="col-md-4">
                        <span class="fa-stack fa-4x">
                            <i class="fas fa-circle fa-stack-2x text-primary"></i>
                            <i class="fas fa-shopping-cart fa-stack-1x fa-inverse"></i>
                        </span>
                        <h4 class="my-3">Clase TOPIK</h4>
                        <p class="text-muted">Si deseas estudiar o vivir en Corea, se requiere el certificado TOPIK, el examen oficial de idioma coreano. Tengo un certificado de TOPIK nivel 6 y ya tengo todos los materiales para el examen. ¡No sufras solo! Estudiemos juntos.</p>
                    </div>
                    <div class="col-md-4">
                        <span class="fa-stack fa-4x">
                            <i class="fas fa-circle fa-stack-2x text-primary"></i>
                            <i class="fas fa-laptop fa-stack-1x fa-inverse"></i>
                        </span>
                        <h4 class="my-3">8 años de experiencia</h4>
                        <p class="text-muted">He trabajado como profesora de español y coreano durante 8 años. Enseñar es mi pasión y misión y si me lo permite la vida, quisiera ser profesora por el resto de mi vida. Mi carrera es la prueba de cuánto amor y pasión tengo por este trabajo, no solo de mi habilidad.</p>
                    </div>
                    <div class="col-md-4">
                        <span class="fa-stack fa-4x">
                            <i class="fas fa-circle fa-stack-2x text-primary"></i>
                            <i class="fas fa-lock fa-stack-1x fa-inverse"></i>
                        </span>
                        <h4 class="my-3">Clase a tu gusto</h4>
                        <p class="text-muted">La mejor forma de aprender una lengua es vivir la cultura. En mis clases se aprende el idioma a través de la música, videos y diversión. Vamos a estudiar el coreano de una forma fácil y divertida.</p>
                    </div>
                </div>
                <div class="text-center" style={{marginTop: '5rem'}}>
                    <h2 class="section-heading text-uppercase">Información General</h2>
                    <div class="row">
                        <div class="col-md-4"><h5 class="my-3">Inscripciones abiertas</h5></div>
                        <div class="col-md-8" style={{margin: '1rem 0', textAlign: 'left'}}><div>Inscríbete en <a href="https://www.kimchilingua.com">www.kimchilingua.com</a> *CUPO LIMITADO*</div></div>
                    </div>
                    <div class="row">
                        <div class="col-md-4"><h5 class="my-3">Duración del curso</h5></div>
                        <div class="col-md-8" style={{margin: '1rem 0', textAlign: 'left'}}>
                            <div>Un mes y medio a partir de la primera clase (TOPIKⅠ: un mes)</div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4"><h5 class="my-3">Número de clases por nivel</h5></div>
                        <div class="col-md-8" style={{margin: '1rem 0', textAlign: 'left'}}>
                            <div>12 clases de 2 horas c/u. 24 horas totales del curso</div>
                            <div>(TOPIKⅠ: 8 clases de 8 horas c/u. 16 horas totales del curso)</div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4"><h5 class="my-3">Costo</h5></div>
                        <div class="col-md-8" style={{margin: '1rem 0', textAlign: 'left'}}>
                            <div>₩120,000 KRW equivalentes a $100 USD para el nivel básico y TOPIKⅠ</div>
                            <div>₩130,000 KRW equivalentes a $110 USD nivel intermedio</div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4"><h5 class="my-3">Método de pago</h5></div>
                        <div class="col-md-8" style={{margin: '1rem 0', textAlign: 'left'}}>
                            <div>Paypal (elena.h.lee@gmail.com)</div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4"><h5 class="my-3">Disponibles para</h5></div>
                        <div class="col-md-8" style={{margin: '1rem 0', textAlign: 'left'}}>
                            <div>personas de 10 años en adelante</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        </>
    )
}

export default Inicio;